import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const formVideo = document.querySelector('.form-video');
	const formVideoForm = document.querySelector('.form-video form');
	const formVideoEmbed = document.querySelector('.embed.form-video-embed');
	const formVideoHideElement = document.querySelector('.form-video-hide-element');

	const formVideoOriginalHeading = document.querySelector('.form-video-original-heading');
	const formVideoAlternateHeading = document.querySelector('.form-video-alternate-heading');

	if (formVideo && formVideoEmbed) {
		formVideoForm.addEventListener('esFormsAfterFormSubmitSuccess', () => {
			formVideoEmbed.classList.add('visible');
			formVideo.classList.add('visible');

			// Hide additional element
			if (formVideoHideElement) {
				formVideoHideElement.style.display = 'none';
			}

			if (formVideoOriginalHeading && formVideoAlternateHeading) {
				formVideoOriginalHeading.style.display = 'none';
				formVideoAlternateHeading.style.display = 'block';
			}
		});
	}
});
